import { observer } from 'mobx-react-lite';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/stores/RootStore';
import SubPageHero from '@/components/SubPageHero';
import AccountPanel from './AccountPanel';
import MyInquiries from '@/pages/support/MyInquiries';
import MyAs from '@/pages/support/MyAs';
import AsForm from '@/pages/support/AsForm';
import m from './Member.module.scss';

/**
 * [2026-09-13 사용자 확정] 마이페이지 = URL 탭 셸.
 *   첫 탭 = 사용자 정보(관리자면 '내 정보') = 계정 정보/설정(AccountPanel). 나머지 탭 = 내 문의·A/S 현황·A/S 신청(embedded).
 *   ★URL 탭(/mypage, /mypage/inquiries, /mypage/as, /mypage/as-apply) → 브라우저 뒤로가기·북마크·새로고침 정상. 탭바 항상 보여 '돌아갈 길' 확보.
 *   ★계정 정보를 별도 페이지가 아닌 탭으로 통합해 관리자/사용자 UX 혼란 제거(사용자 요청). 관리자 대시보드는 /admin.
 */
function MyPage() {
	const auth = useAuth();
	const nav = useNavigate();
	const { tab } = useParams();

	if (auth.ready && !auth.isAuthed) return <Navigate to="/login" replace />;
	const u = auth.user;
	if (!u) return <div className={m.page} />;
	const isAdmin = u.role === 'ADMIN';
	const cur = tab || 'info';
	const TABS = [
		{ k: 'info', label: isAdmin ? '내 정보' : '사용자 정보', to: '/mypage' },
		{ k: 'inquiries', label: '내 문의', to: '/mypage/inquiries' },
		{ k: 'as', label: 'A/S 현황', to: '/mypage/as' },
		{ k: 'as-apply', label: 'A/S 신청', to: '/mypage/as-apply' },
	];

	return (
		<>
			<SubPageHero align="left" title="마이페이지" subtitle="내 정보와 활동을 관리합니다"
				image="/images/auth/member-hero.jpg" crumbs={[{ label: 'HOME' }, { label: '마이페이지' }]} />
			<div className={m.page}>
				<div className={m.wrap}>
					<p className={m.eyebrow}>MY ACCOUNT</p>
					<h2 className={m.h2}>{u.name}님, <b>안녕하세요</b></h2>
					<p className={m.lead}>내 정보와 활동을 한곳에서 관리합니다.</p>
					<div className={m.tabs}>
						{TABS.map((t) => (
							<button key={t.k} className={`${m.tab} ${cur === t.k ? m.tabOn : ''}`} onClick={() => nav(t.to)}>{t.label}</button>
						))}
					</div>
					{cur === 'info' && <AccountPanel />}
					{cur === 'inquiries' && <MyInquiries embedded />}
					{cur === 'as' && <MyAs embedded />}
					{cur === 'as-apply' && <AsForm embedded />}
				</div>
			</div>
		</>
	);
}

export default observer(MyPage);
